export default __webpack_public_path__ + "static/media/Type B main cover.60a5c3dd.png";